import NextImage from 'next/image';
import { useState } from 'react';
import { getAvifImagePath } from '@/utils/images';

const getContentType = (src) => {
  const parts = src.toLowerCase().split('.');
  const extension = parts[parts.length - 1];
  switch (extension) {
    case 'png':
      return 'image/png';
    default:
      return 'image/jpeg';
  }
};

const Image = ({
  src,
  alt,
  className,
  fallback,
  priority,
  unoptimized,
  sizes = '(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw',
}) => {
  const [errored, setErrored] = useState(false);

  const onError = () => {
    setErrored(true);
  };

  const showFallback = errored && fallback;
  const imageToShow = showFallback ? fallback : src;
  const useAvif = imageToShow.indexOf('https://assets.bidali.com/commerce/brands/other/') === -1;
  const nextImageSrc = useAvif && !showFallback ? getAvifImagePath(imageToShow) : imageToShow;

  return (
    <picture>
      {useAvif && <source srcSet={getAvifImagePath(imageToShow)} type="image/avif" />}
      <source srcSet={imageToShow} type={getContentType(imageToShow)} />
      <NextImage
        height={150}
        width={250}
        src={nextImageSrc}
        alt={alt}
        className={className}
        onError={onError}
        priority={priority}
        fetchPriority={priority ? 'high' : undefined}
        sizes={sizes}
        unoptimized={unoptimized}
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </picture>
  );
};

export default Image;
